(($, THERMOS) => {

	// MV
	var mvToggle = document.querySelector('.top-mainVis__left .splide__toggle');
	var mvSection = document.querySelector('.top-mainVis');
	var mvPaused = false;
	if (mvToggle && mvSection) mvSection.appendChild(mvToggle);

	// MV左側
	var splide_mv_left = new Splide('.top-mainVis__left.splide', {
		type: 'fade',
		rewind: true,
		arrows: false,
		pagination: true,
		paginationKeyboard: true,
		speed: 3000,
		autoplay: true,
		interval: 5000,
		pauseOnHover: false,
		pauseOnFocus: false
	});
	splide_mv_left.mount();

	// MV右側
	var MV_RIGHT_PC_MODE = 'ticker';

	var MV_RING_CIRCUMFERENCE = 50.27;
	var MV_RING_SVG = '<svg class="__ring" viewBox="0 0 20 20" aria-hidden="true" focusable="false">'
		+ '<circle class="__base" cx="10" cy="10" r="8"></circle>'
		+ '<circle class="__bar" cx="10" cy="10" r="8"></circle>'
		+ '</svg>';

	function attachRingPagination(splide) {
		splide.on('pagination:mounted', function (data) {
			data.items.forEach(function (item) {
				item.button.insertAdjacentHTML('beforeend', MV_RING_SVG);
			});
		});
		splide.on('autoplay:playing', function (rate) {
			var bar = document.querySelector('.top-mainVis__right .splide__pagination__page.is-active .__bar');
			if (bar) bar.style.strokeDashoffset = MV_RING_CIRCUMFERENCE * (1 - rate);
		});
		splide.on('move', function () {
			document.querySelectorAll('.top-mainVis__right .__bar').forEach(function (bar) {
				bar.style.strokeDashoffset = MV_RING_CIRCUMFERENCE;
			});
		});
	}

	var splide_mv_right = null;
	var prevIsSp = window.matchMedia('(max-width:1024px)').matches;

	function initRightSlider() {
		if (splide_mv_right) splide_mv_right.destroy();

		var isSp = window.matchMedia('(max-width:1024px)').matches;

		if (isSp) {
			splide_mv_right = new Splide('.top-mainVis__right.splide', {
				type: 'loop',
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
				drag: true,
				autoplay: true,
				interval: 4000,
				pauseOnHover: false,
				speed: 500,
				fixedWidth: '200px',
				focus: 'center',
				gap: '8px'
			});
			splide_mv_right.mount();
		} else if (MV_RIGHT_PC_MODE === 'step') {
			splide_mv_right = new Splide('.top-mainVis__right.splide', {
				direction: 'ttb',
				height: '50vw',
				type: 'loop',
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
				gap: '20px',
				drag: true,
				wheel: true,
				wheelMinThreshold: 10,
				wheelSleep: 300,
				autoplay: true,
				interval: 4000,
				speed: 600,
				pauseOnHover: true,
				resetProgress: false,
				focus: 'center'
			});
			attachRingPagination(splide_mv_right);
			splide_mv_right.mount();
		} else {
			splide_mv_right = new Splide('.top-mainVis__right.splide', {
				direction: 'ttb',
				height: '50vw',
				type: 'loop',
				arrows: false,
				pagination: true,
				paginationKeyboard: true,
				gap: '20px',
				drag: 'free',
				wheel: true,
				wheelMinThreshold: 10,
				wheelSleep: 300,
				focus: 'center', // 2枚目中央化を回避
				autoScroll: {
					speed: 1,
					pauseOnHover: true,
					pauseOnFocus: false,
					rewind: false
				}
			});
			splide_mv_right.mount(window.splide.Extensions);
		}

		if (mvPaused) pauseMvRight();
	}

	initRightSlider();

	// MV右側の停止/再開
	function pauseMvRight() {
		if (!splide_mv_right) return;
		if (splide_mv_right.Components.AutoScroll) {
			splide_mv_right.Components.AutoScroll.pause();
		} else if (splide_mv_right.Components.Autoplay) {
			splide_mv_right.Components.Autoplay.pause();
		}
	}
	function playMvRight() {
		if (!splide_mv_right) return;
		if (splide_mv_right.Components.AutoScroll) {
			splide_mv_right.Components.AutoScroll.play();
		} else if (splide_mv_right.Components.Autoplay) {
			splide_mv_right.Components.Autoplay.play();
		}
	}

	// MV停止ボタン
	var MV_TOGGLE_LABEL_PAUSE = 'MV全体（ブランドイメージ・バナー）の自動スクロールを止める';
	var MV_TOGGLE_LABEL_PLAY = 'MV全体（ブランドイメージ・バナー）を自動スクロールする';
	if (mvToggle) {
		mvToggle.classList.add('is-active');
		mvToggle.setAttribute('aria-label', MV_TOGGLE_LABEL_PAUSE);
		mvToggle.addEventListener('click', function () {
			mvPaused = !mvPaused;
			this.classList.toggle('is-active', !mvPaused);
			this.setAttribute('aria-label', mvPaused ? MV_TOGGLE_LABEL_PLAY : MV_TOGGLE_LABEL_PAUSE);
			if (mvPaused) {
				splide_mv_left.Components.Autoplay.pause();
				pauseMvRight();
			} else {
				splide_mv_left.Components.Autoplay.play();
				playMvRight();
			}
		});
	}

	// MVプログレス
	splide_mv_left.on('autoplay:play', function () {
		var pg = document.querySelector('.top-mainVis__left .splide__pagination');
		if (pg) pg.classList.remove('is-paused');
	});
	splide_mv_left.on('autoplay:pause', function () {
		var pg = document.querySelector('.top-mainVis__left .splide__pagination');
		if (pg) pg.classList.add('is-paused');
	});

	// PC/SP切替
	var resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			var nowIsSp = window.matchMedia('(max-width:1024px)').matches;
			if (nowIsSp !== prevIsSp) {
				prevIsSp = nowIsSp;
				initRightSlider();
			}
		}, 300);
	});

	// レシピ
	var splide_recipe = new Splide('.top-recipe-list.splide', {
		type: 'loop',
		arrows: true,
		pagination: true,
		paginationKeyboard: true,
		speed: 500,
		autoplay: false,
		autoWidth: true,
		focus: 0
	});
	splide_recipe.mount();

	// ウェブマガジン
	var splide_webmagazine = new Splide('.top-webmagazine-list.splide', {
		arrows: false,
		pagination: true,
		paginationKeyboard: true,
		speed: 500,
		autoplay: false,
		autoWidth: true,
		focus: 0,
		omitEnd: true,
	});
	splide_webmagazine.mount();

})(window.jQuery, window.THERMOS);
